import React from 'react';
import PaginatorV3 from 'components/Paginator/PaginatorV3';

const RecentAlertsSection = ({
	notifications,
	isLoading,
	error,
	pagination,
	onPageChange,
}) => {
	if (isLoading) {
		return (
			<div className="property-section-card">
				<div className="property-section-header">
					<h5>
						<i className="bi bi-bell" />
						Recent Alerts (0)
					</h5>
				</div>
				<div className="property-section-body">
					<div className="loading-state">
						<div className="spinner-border" role="status">
							<span className="visually-hidden">Loading notifications...</span>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="alerts-table">
			{!notifications || notifications.length === 0 ? (
				<div className="property-section-body empty-state">
					<i className="bi bi-bell-slash" />
					<p>No recent alerts for this property.</p>
				</div>
			) : (
				<>
					<div className="table-responsive">
						<table className="table mb-0">
							<thead>
								<tr>
									<th>Date/Time</th>
									<th>Property</th>
									<th>Alert</th>
									{/* <th>Agency</th> */}
								</tr>
							</thead>
							<tbody>
								{notifications.map((notification) => (
									<tr
										key={notification.id}
										className={notification.read ? 'read' : 'unread'}
										style={{
											cursor: notification.url ? 'pointer' : 'default',
										}}
										onClick={() => {
											if (notification.url) {
												window.open(notification.url, '_blank');
											}
										}}
									>
										<td>
											{notification.date
												? new Date(notification.date).toLocaleDateString()
												: notification.created_at
												? new Date(notification.created_at).toLocaleDateString()
												: '-'}
										</td>
										<td>{notification.property?.address || '-'}</td>
										<td>
											<span
												className={`badge bg-${
													notification.priority === 'high'
														? 'danger'
														: notification.priority === 'medium'
														? 'warning'
														: 'success'
												}`}
											>
												{notification.notificationType?.name || 'Alert'}
											</span>
										</td>
										{/* <td>
											{notification.notificationType?.dataSource?.name || '-'}
										</td> */}
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{/* Pagination (violerts-v3-root gives PaginatorV3 its button reset, same as AlertsTable) */}
					{pagination.total > pagination.perPage && (
						<div className="recent-alerts-paginator violerts-v3-root tw-flex tw-justify-center tw-pt-4">
							<PaginatorV3
								currentPage={pagination.currentPage || 1}
								totalPages={Math.ceil(pagination.total / pagination.perPage)}
								onPageChange={onPageChange}
							/>
						</div>
					)}
				</>
			)}
		</div>
	);
};

export default RecentAlertsSection;
